module.exports = __webpack_public_path__ + "img/ic_meal.04809231.svg";